<template>
<div>
    <!-- 个人资料 -->
    <el-dialog class="detailwrap" v-if="profileTableVisible" :visible.sync="profileTableVisible" :before-close="profile_dialog_close" append-to-body>
        <div class="detailbg">
			<hr color="0080ff">
			<el-row>
				<el-col :span="6" class="userface">
					<div id="header_div">
						<div id="header_type" ref="header_type">
						</div>
						<div id="eye_type" ref="eye_type">
						</div>
						<div id="mouth_type" ref="mouth_type">
						</div>
						<div id="hair_type" ref="hair_type">
						</div>
					</div>
				</el-col>
				<el-col :span="16">
					<div class="detailTitle">基本资料：</div>
					<div class="detailLine">
						<span class="detailLabel">用户名：</span>
						<span class="detailValue">{{fantasyUserBO.userName}}</span>
					</div>
					<div class="detailLine">
						<span class="detailLabel">昵　称：</span>
                        <span class="detailValue" v-show="editingNickName == false">
							{{fantasyUserBO.nickName}}
							<el-button type="primary" icon="el-icon-edit" plain size="mini" @click="editingNickName = true; newNickName=fantasyUserBO.nickName;"></el-button>
						</span>
                        <span v-show="editingNickName">
							<el-input size="mini" placeholder="请输入昵称" class="nickName" maxlength=10 v-model.trim="newNickName"/>
							<el-button type="success" icon="el-icon-check" plain size="mini" @click="changeNickName();"></el-button>
						</span>
					</div>
					<div class="detailLine">
						<span class="detailLabel">密　码：</span>
						<span class="detailValue"><el-button type="primary" icon="el-icon-edit" plain size="mini" @click="showPassChange();"></el-button></span>
					</div>
					<div class="detailLine">
						<span class="detailLabel">手机号：</span>
						<span class="detailValue">{{fantasyUserBO.mobile}}</span>
					</div>
					<div class="detailLine">
						<span class="detailLabel">邮　箱：</span>
						<span class="detailValue">{{fantasyUserBO.email}}</span>
					</div>
					<div class="detailLine">
						<span class="detailLabel">简　介：</span>
                        <span class="detailValue" v-show="editingRemark == false" :title="fantasyUserBO.remark">
							<span v-if="fantasyUserBO.remark!=null && fantasyUserBO.remark.length > 10">
								{{fantasyUserBO.remark.substring(0,10)}}...
							</span>
							<span v-else>
								{{fantasyUserBO.remark}}
							</span>
							<el-button type="primary" icon="el-icon-edit" plain size="mini" @click="editingRemark = true; newRemark=fantasyUserBO.remark;"></el-button>
						</span>
                        <span v-show="editingRemark">
							<el-input size="mini" placeholder="请输入简介" class="nickName" maxlength=200 v-model.trim="newRemark"/>
							<el-button type="success" icon="el-icon-check" plain size="mini" @click="changeRemark();"></el-button>
						</span>
						<span class="detailValue"></span>
					</div>
				</el-col>
				<el-col :span="2"></el-col>
			</el-row>
			<hr color="0080ff">
			<el-row>
				<el-col :span="6">&nbsp;</el-col>
				<el-col :span="16">
					<div class="detailTitle">社区资料：</div>
					<div class="detailLine">
						<span class="detailLabel">经　验：</span>
						<span class="detailValue">{{fantasyUserDetail.exp}}</span>
					</div>
					<div class="detailLine">
						<span class="detailLabel">等　级：</span>
						<span class="detailValue">{{fantasyUserDetail.level}}</span>
					</div>
					<div class="detailLine">
						<span class="detailLabel">称　号：</span>
						<span class="detailValue">{{fantasyUserDetail.chenghao}}</span>
					</div>
				</el-col>
				<el-col :span="2"></el-col>
			</el-row>
		</div>
    </el-dialog>
	
    <!-- 密码修改 -->
    <el-dialog class="detailwrap" title="密码修改" :visible.sync="passChangeTableVisible" :before-close="pass_change_dialog_close" append-to-body>
        <div class="detailbg">
			<hr color="0080ff">
			<el-row>
				<el-col :span="6"></el-col>
				<el-col :span="16">
					<div class="detailLine">
						<span class="detailLabel">当前密码：</span>
						<span class="detailValue"><el-input type="password" size="mini" placeholder="请输入当前密码" class="password" maxlength=20 v-model.trim="curPass"/></span>
					</div>
					<div class="detailLine">
						<span class="detailLabel">新的密码：</span>
						<span class="detailValue"><el-input type="password" size="mini" placeholder="请输入新密码" class="password" maxlength=20 v-model.trim="newPass"/></span>
					</div>
					<div class="detailLine">
						<span class="detailLabel">重输密码：</span>
						<span class="detailValue"><el-input type="password" size="mini" placeholder="请重新输入新密码" class="password" maxlength=20 v-model.trim="newPass2"/></span>
					</div>
					<div class="detailLine">
						<el-button type="success" icon="el-icon-check"  @click="changePass();"></el-button>
					</div>
				</el-col>
				<el-col :span="2"></el-col>
			</el-row>
		</div>
    </el-dialog>
</div>
</template>

<script>
import {postRequest} from '../../utils/api'
import {getRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
	name: 'profile',
	props:{
		profileTableVisible: {
		type: Boolean,
		default: false
		},
		fantasyUserBO: Object,
	},
	data() {
		return {
			editingNickName: false,
			newNickName: "",
			editingRemark: false,
			newRemark: "",
			passChangeTableVisible: false,
			curPass: "",
			newPass: "",
			newPass2: "",
			fantasyUserDetail: {},
			fantasyUserProperty: {},
			fantasyUserHeader: {},
		};
	},
	computed: {
	},
	watch: {
		profileTableVisible: {
			handler(newVal) {
				if (newVal === true) {
					this.initProfile();
				}
			}
		}
	},
	mounted:  function (){
		if (true == this.profileTableVisible) {
			this.initProfile();
		}
	},
	methods: {
		initProfile() {
			var _this = this;
			getRequest('/user/user/showCurUserDetail', {
			}).then(resp=> {
				if (resp.status == 200) {
				//成功
				var respData = resp.data;
				//alert(JSON.stringify(data))
				//alert(data.result == false)
				if (200 == respData.status) {
					_this.fantasyUserDetail = respData.data.fantasyUserDetail;
					_this.fantasyUserProperty = respData.data.fantasyUserProperty;
					_this.fantasyUserHeader = respData.data.userHeader;
					_this.$nextTick(() => {
						try {
							if (_this.fantasyUserHeader.mouthUrl && _this.$refs.mouth_type) _this.$refs.mouth_type.style.backgroundImage = "url(" + _this.ossPath + _this.fantasyUserHeader.mouthUrl + ")";
							if (_this.fantasyUserHeader.faceUrl && _this.$refs.header_type) _this.$refs.header_type.style.backgroundImage = "url(" + _this.ossPath + _this.fantasyUserHeader.faceUrl + ")";
							if (_this.fantasyUserHeader.eyeUrl && _this.$refs.eye_type) _this.$refs.eye_type.style.backgroundImage = "url(" + _this.ossPath + _this.fantasyUserHeader.eyeUrl + ")";
							if (_this.fantasyUserHeader.hairUrl && _this.$refs.hair_type) _this.$refs.hair_type.style.backgroundImage = "url(" + _this.ossPath + _this.fantasyUserHeader.hairUrl + ")";
						} catch (e) {}
					});
				} else {
					Message.error(respData.message, '失败!');
				}
				} else {
					//失败
					Message.error('查询用户详情失败');
				}
			}, resp=> {
				Message.error('查询用户详情异常');
			});
		},
		profile_dialog_close(){
			this.$emit("profile_dialog_close");
		},
		//修改昵称
		changeNickName() {
			if (this.newNickName == "" || this.newNickName == this.fantasyUserBO.nickName) {
				this.editingNickName = false;
				return ;
			} else if (this.newNickName.length > 9) {
				Message.warning("昵称长度过长，请修改。");
				this.editingNickName = false;
				return ;
			}
			postRequest('/user/user/changeNickName', {
				nickName: this.newNickName
			}).then(resp=> {
				if (resp.status == 200) {
					//成功
					var respData = resp.data;
					if (200 == respData.status) {
						this.$store.commit('user/SET_FANTASY_USER', respData.data);
						Message.success(respData.message);
					} else {
						Message.error(respData.message);
					}
				} else {
				//失败
				Message.error('用户非法⊙﹏⊙∥!');
				}
			}, resp=> {
				Message.error('用户非法⊙﹏⊙∥!');
			});
			this.editingNickName = false;
		},
		//修改简介
		changeRemark() {
			if (this.newRemark == "" || this.newRemark == this.fantasyUserBO.remark) {
				this.editingRemark = false;
				return ;
			} else if (this.newRemark.length > 200) {
				Message.warning("简介长度过长，请修改。");
				this.editingRemark = false;
				return ;
			}
			postRequest('/user/user/changeRemark', {
				remark: this.newRemark
			}).then(resp=> {
				if (resp.status == 200) {
					//成功
					var respData = resp.data;
					if (200 == respData.status) {
						this.$store.commit('user/SET_FANTASY_USER', respData.data);
						Message.success(respData.message);
					} else {
						Message.error(respData.message);
					}
				} else {
				//失败
				Message.error('用户非法⊙﹏⊙∥!');
				}
			}, resp=> {
				Message.error('用户非法⊙﹏⊙∥!');
			});
			this.editingRemark = false;
		},
		
		pass_change_dialog_close(){
			this.passChangeTableVisible = false;
		},
		//打开个人资料窗口
		showPassChange() {
			this.passChangeTableVisible = true;
		},
		//修改密码
		changePass() {
			if (this.newPass != this.newPass2) {
				Message.error('两次输入的新密码不一致,请检查', '提示');
				return;
			}
			var _this = this;
			postRequest('/user/user/changePassword', {
				curPass: this.curPass,
				newPass: this.newPass
			}).then(resp=> {
				if (resp.status == 200) {
					//成功
					var respData = resp.data;
					if (200 == respData.status) {
						this.passChangeTableVisible = false;
						this.curPass = "";
						this.newPass = "";
						this.newPass2 = "";
						Message.success(respData.message);
					} else {
						Message.error(respData.message);
					}
				} else {
					//失败
					Message.error('用户非法⊙﹏⊙∥!1');
				}
			}, resp=> {
				Message.error('用户非法⊙﹏⊙∥!2');
			});
		}
	}
}
</script>

<style >
.detailwrap {
    margin:auto;
    width: 80%;
}
.el-dialog {
	background: #fdffea;
}
.detailbg {
    background: #fdffea;
}
.detailTitle {
    color: #70afbe;
}
.detailLabel {
    color: #7d7a75;
}
.detailValue {
    color: #92655f;
}
.detailwrap .nickName {
	width: 100px;
}
.detailwrap hr {
	margin-top: 5px;
	margin-bottom: 5px;
}
.detailLine {
	line-height: 30px;
}
.detailwrap .password {
	width: 150px;
}

#header_div {
	width:64px;
	height:80px;
  background-size:64px 80px;
  -moz-background-size:64px 80px;
	position:relative;
}

#header_div #hair_type {
	width:64px;
	height:80px;
	background-size:64px 80px;
	background-repeat:no-repeat;
	position:absolute;
}

#header_div #eye_type {
	width:64px;
	height:80px;
	background-size:64px 80px;
	background-repeat:no-repeat;
	position:absolute;
}

#header_div #mouth_type {
	width:64px;
	height:80px;
	background-size:64px 80px;
	background-repeat:no-repeat;
	position:absolute;
}

#header_div #header_type {
	width:64px;
	height:80px;
	background-size:64px 80px;
	background-repeat:no-repeat;
	position:absolute;
}
</style>